<ng-container #formDirective=parent-form thr-parent-form>
    <div class="row">
        <div class="col-12">
            <mat-accordion class="full-data-legal" [displayMode]="'flat'" [multi]="true">
                <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                        <mat-panel-title>
                            <h2 class="mat-subheading-1 mb-0">
                                4.1 {{ 'full-data.type-entity'|translate }}
                            </h2>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="bg-gray-gradient pt-3">
                        <h3 class="mat-subheading-1 font-weight-bold mb-0">
                            {{ 'full-data.status-contract-holder'|translate }}
                        </h3>
                        <p class="font-italic">
                            {{ 'full-data.only-one-options'|translate }}:
                        </p>

                        <mat-radio-group name="fdflpTypeOfEntity" [(ngModel)]="client.fatca.typeOfEntity" (ngModelChange)="onResize()" [required]="true" [disabled]="isDisabled">
                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                a) {{ 'full-data.fatca.entity-of'|translate }}
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpA1" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.A1">
                                        a.1. {{ 'full-data.fatca.investment-entity'|translate }}
                                    </mat-radio-button>

                                    <div class="ml-sm-4 pl-sm-2 mb-5" *ngIf="client.fatca.typeOfEntity === FatcaTypeEntity.A1">
                                        <thr-full-data-form-fatca-single-manager [fatca]="client.fatca" [isDisabled]="isDisabled"></thr-full-data-form-fatca-single-manager>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <mat-radio-button name="fdflpA2" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.A2">
                                        a.2. {{ 'full-data.fatca.other-investment-entity'|translate }}
                                    </mat-radio-button>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                b) {{ 'full-data.fatca.financial-institutions'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpB" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.B">
                                        {{ 'full-data.fatca.depository-institution'|translate }}
                                    </mat-radio-button>

                                    <div class="ml-sm-4 pl-sm-2 mb-5" *ngIf="client.fatca.typeOfEntity === FatcaTypeEntity.B">
                                        <p>{{ 'full-data.giin-fatca'|translate }}</p>
                                        <mat-form-field class="full-width">
                                            <input name="giin" matInput [placeholder]="'form.giin'|translate" required [disabled]="isDisabled" [(ngModel)]="client.fatca.giin" #giinCtrl="ngModel">
                                            <mat-error *ngIf="giinCtrl.hasError('required')">
                                                {{ 'form.validation.required'|translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                c) {{ 'full-data.fatca.active-enf'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpC" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.C">
                                        {{ 'full-data.fatca.company-shares-regularly-traded'|translate }}
                                    </mat-radio-button>

                                    <div class="ml-sm-4 pl-sm-2 mb-5" *ngIf="client.fatca.typeOfEntity === FatcaTypeEntity.C">
                                        <p>{{ 'full-data.indicates-name-stock-market'|translate }}</p>
                                        <mat-form-field class="full-width mb-3 mb-sm-4">
                                            <input name="nameMarket" matInput [placeholder]="'form.name-market'|translate" required [disabled]="isDisabled" [(ngModel)]="client.fatca.nameMarket" #nameMarketCtrl="ngModel">
                                            <mat-error *ngIf="nameMarketCtrl.hasError('required')">
                                                {{ 'form.validation.required'|translate }}
                                            </mat-error>
                                        </mat-form-field>

                                        <p>{{ 'full-data.company-linked-listed-company'|translate }}</p>
                                        <mat-form-field class="full-width">
                                            <input name="nameSociety" matInput [placeholder]="'form.name-society'|translate" required [disabled]="isDisabled" [(ngModel)]="client.fatca.nameSociety" #nameSocietyCtrl="ngModel">
                                            <mat-error *ngIf="nameSocietyCtrl.hasError('required')">
                                                {{ 'form.validation.required'|translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                d) {{ 'full-data.fatca.active-enf'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpD" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.D">
                                        {{ 'full-data.fatca.government-entity'|translate }}
                                    </mat-radio-button>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                e) {{ 'full-data.fatca.active-enf'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpE" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.E">
                                        {{ 'full-data.fatca.international-organization'|translate }}
                                    </mat-radio-button>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                f) {{ 'full-data.fatca.active-enf'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpF" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.F">
                                        {{ 'full-data.fatca.newly-created-NFE'|translate }}
                                    </mat-radio-button>
                                </div>
                            </div>

                            <h3 class="mat-subheading-1 font-weight-bold text-blue">
                                g) {{ 'full-data.fatca.passive-enf'|translate }}:
                            </h3>

                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button name="fdflpG" class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="FatcaTypeEntity.G">
                                        {{ 'full-data.fatca.passive-non-financial-entity'|translate }}
                                    </mat-radio-button>

                                    <div class="ml-sm-4 pl-sm-2 mb-5" *ngIf="client.fatca.typeOfEntity === FatcaTypeEntity.G">
                                        <thr-full-data-form-fatca-single-manager [fatca]="client.fatca" [isDisabled]="isDisabled"></thr-full-data-form-fatca-single-manager>
                                    </div>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                        <mat-panel-title>
                            <h2 class="mat-subheading-1 mb-0">
                                4.2 {{ 'full-data.tax-residence-client'|translate }}
                            </h2>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="bg-gray-gradient pt-3">
                        <thr-full-data-form-legal-tax [tax]="client.fatca.tax" [isLegalPerson]="true" [isDisabled]="isDisabled"></thr-full-data-form-legal-tax>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true" [hideToggle]="true" (afterCollapse)="onResize()" (afterExpand)="onResize()">
                    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                        <mat-panel-title>
                            <h2 class="mat-subheading-1 mb-0">
                                4.3 {{ 'full-data.declaration-signature'|translate }}
                            </h2>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="bg-gray-gradient pt-3">
                        <h3 class="mat-subheading-1 font-weight-bold text-blue">
                            {{ 'full-data.type-declaration'|translate }}
                        </h3>

                        <mat-radio-group name="fdflpTypeSign" [value]="1" [required]="true" [disabled]="true">
                            <div class="row">
                                <div class="col-12">
                                    <mat-radio-button class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="1">
                                        {{ 'form.new-contract-registration'|translate }}
                                    </mat-radio-button>
                                </div>
                                <div class="col-12">
                                    <mat-radio-button class="font-weight-bold mb-3 mb-sm-4" color="blue-gray" [value]="2">
                                        {{ 'form.modification-contract'|translate }}
                                    </mat-radio-button>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                {{ 'general.save'|translate }}
            </button>
        </div>
    </div>
</ng-container>